// import { Link } from 'react-router-dom';
// import { AppContext} from '../Components/AppState';
// import {useContext } from 'react'

let NavBar = ()  => {

    // const context = useContext(AppContext);
    return(
         <nav>
        {
            // {context.state.isUserLoggedIn
            // ? ( <Link to="/home"> Home </Link> )
            // : (
                <> 
                {/* <Link to="/register">Sign Up</Link>
                <Link to="/login"> Login</Link> */}
                </>
            // )}
        }
    </nav>
    )
}

export default NavBar;